import script from "./TestViewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestViewPage.vue?vue&type=script&setup=true&lang=ts"

import "./TestViewPage.vue?vue&type=style&index=0&id=7c651817&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c651817"]])

export default __exports__